<div class="kpi-selection-modal-container">
    <div class="modal-header">
        <div class="modal-title">
            KPI SELECTION
        </div>
        <div class="modal-close-button" (click)="onCloseButtonClick()">
            <img class="closeIcon" src=""/>
        </div>
    </div>
    <div class="modal-body">
        <ng-container *ngIf="!kpisLoading">
            <div class="title">
                Select KPIs for {{selectedPlant.plantName}}
            </div>
            <div class="sub-title">
                Note: The disabled items have already been configured!
            </div>
            <div class="kpi-options-container" *ngIf="kpiList.length > 0 || disabledKpiList.length > 0">
                <div class="kpi-options">
                    <ng-container class="kpi-option">
                        <mat-checkbox [disabled]="kpiList.length === 0"
                        (change)="selectAll($event.checked)" 
                        [checked]="allSelected"
                        [indeterminate]="someSelected">
                            <div class="kpi-options-text">
                                Select All
                            </div>
                        </mat-checkbox> 
                    </ng-container>
                    <ng-container class="kpi-option" *ngFor="let kpi of kpiList">
                        <mat-checkbox
                        [(ngModel)]="kpi.selected"
                        (ngModelChange)="onKpiSelected()" >
                            <span appTooltip="{{kpi.name}}" [tooltipPosition]="'top'"
                            [tooltipShow]="(kpi.name.length) > 24">
                                <div class="kpi-options-text">
                                    {{kpi.name | shorten: 24}}
                                </div>
                            </span>
                        </mat-checkbox>
                    </ng-container>
                    <ng-container class="kpi-option" *ngFor="let disabledKpi of disabledKpiList">
                        <mat-checkbox disabled>
                            <span appTooltip="{{disabledKpi.name}}" [tooltipPosition]="'top'"
                            [tooltipShow]="(disabledKpi.name.length) > 24">
                                <div class="kpi-options-text">
                                    {{disabledKpi.name | shorten: 24}}
                                </div>
                            </span>
                        </mat-checkbox>
                    </ng-container>
                </div>
            </div>
            <div class="no-kpi-message" *ngIf="kpiList.length === 0 && disabledKpiList.length === 0">
                <img class="icon infoIcon" src=""/>
                <div class="message">No available KPIs to configure</div>
            </div>
            <div class="select-button-container">
                <button (click)="submit()" [ngClass]="{'select-button-disabled': !allSelected && !someSelected || kpiList.length === 0 && disabledKpiList.length === 0, 'select-button-enabled' : allSelected || someSelected}" [disabled]="!allSelected && !someSelected || kpiList.length === 0 && disabledKpiList.length === 0">
                    <div class="select-button-text">
                        SELECT({{count}})
                    </div>
                </button>
            </div>
        </ng-container>
        <ng-container *ngIf="kpisLoading">
            <div class="loading-kpis">
                <app-three-dots-loading class="dots"></app-three-dots-loading>
                <div class="text">Loading KPIs...</div>
            </div>
        </ng-container>
    </div>
</div>